var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  사업장 현황\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }